import Box, { type BoxProps } from '@components/Box';
import { cssMerge } from '@shared/util';
import { forwardRef, type Ref } from 'react';

export type Props = Omit<BoxProps, 'gap'> & {
  ref?: Ref<HTMLDivElement>;
  gap?: 4 | 8 | 16 | 24 | 32 | 48 | 64 | 's' | 'm' | 'l' | 'text';
};

const Stack = forwardRef<HTMLDivElement, Props>(
  ({ gap, children, className, alignItems, ...restProps }, ref) => (
    <Box
      ref={ref}
      {...restProps}
      alignItems={alignItems || (!gap ? 'start' : undefined)}
      className={cssMerge(!gap && 'flex-col', gap && `stack-${gap}`, className)}
    >
      {children}
    </Box>
  ),
);

Stack.displayName = 'Stack';

export default Stack;
